import React, { useEffect, useState } from 'react';
import styles from './TypingText.module.css';

const TypingText = () => {
  const words = ['Future', 'Path', 'Career', 'Success', 'Growth','World'];
  const [index, setIndex] = useState(0);
  const [displayed, setDisplayed] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const currentWord = words[index % words.length];

    const type = () => {
      if (isDeleting) {
        if (charIndex > 0) {
          setDisplayed(currentWord.substring(0, charIndex - 1));
          setCharIndex(charIndex - 1);
        } else {
          setIsDeleting(false);
          setIndex(index + 1);
        }
      } else {
        if (charIndex < currentWord.length) {
          setDisplayed(currentWord.substring(0, charIndex + 1));
          setCharIndex(charIndex + 1);
        } else {
          setTimeout(() => setIsDeleting(true), 1500);
        }
      }
    };

    const timer = setTimeout(type, isDeleting ? 80 : 100);

    return () => clearTimeout(timer);
  }, [charIndex, isDeleting, index]);

  return (
    <div> 
         <h1 className={styles.typedLine}>
           Learning Today,<br /> Leading Tomorrow  Empowering Your Digital&nbsp;
      <span className={styles.dynamic}>{displayed}</span>
      <span className={styles.cursor}>|</span>
    </h1>
    </div>

  );
};

export default TypingText;
